export function ValidObj(value) {
	return {
		value: value,
		first: true,
		wrong: false,
		warn: "",
		showPassword: false,
	}
}